import React from "react";

const InvestmentsGridCard = (props) => {
  return (
    <div className="text-center p-10 shadow-lg w-full">
      <h3 className="m-0 text-center font-medium text-4xl pb-3">{props.top}</h3>
      <p className="m-0 font-normal">
        {props.bottom}
        <sup style={{ fontSize: "10px" }}>{props.footnote}</sup>
      </p>
    </div>
  );
};

export default InvestmentsGridCard;
